import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/DownloadsApi" );

/* eslint-disable arrow-body-style */

/**
 * Method used to load download items
 */
export const loadDownloads = () => {
  return instance.get( "LoadDownloads" );
};

/*
 * Method used to download content from the browser
 *
 * DownloadRequest payload Format:
 *
 * {
 *     files: [
 *         {
 *             url: 'https://example.com/file1.pdf',
 *             fileName: 'file1.pdf',
 *             contentType: 'application/pdf'
 *         },
 *         {
 *             url: 'https://example.com/file2.jpg',
 *             fileName: 'file2.jpg',
 *             contentType: 'image/jpeg'
 *         }
 *     ],
 *     targetFileName: 'my_download.zip',          // Name for the zip file or single file download
 * }
 */
export const download = ( downloadRequest ) => {
  return instance.post( "Download", downloadRequest, null, { responseType: "blob" } );
};
